import {
  ChatAssistantMessageContent,
  ChatAssistantMeta,
  type ChatAssistantMetaInfo,
  ChatUserMessageBubble,
  ChatUserMessageRow,
} from "@/components/chat/chat-dialog-primitives";
import { UIMessage } from "ai";
import { memo } from "react";
import { stripSuggestions } from "./conversation-utils";

type ConversationMessageProps = {
  message: UIMessage<ChatAssistantMetaInfo>;
  isStreaming: boolean;
};

export const ConversationMessage = memo(function ConversationMessage({
  message,
  isStreaming,
}: ConversationMessageProps): React.JSX.Element {
  if (message.role === "user") {
    return (
      <ChatUserMessageRow>
        <ChatUserMessageBubble>
          {message.parts
            .filter((p) => p.type === "text")
            .map((p) => p.text)
            .join("")}
        </ChatUserMessageBubble>
      </ChatUserMessageRow>
    );
  }

  return (
    <div className="relative w-full group">
      <ChatAssistantMessageContent
        messageId={message.id}
        parts={message.parts}
        isStreaming={isStreaming}
        transformText={stripSuggestions}
      />
      {!isStreaming && (
        <ChatAssistantMeta
          llmId={message.metadata?.llmId}
          createdAt={message.metadata?.createdAt}
        />
      )}
    </div>
  );
});
